import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry, Rachel Ralston

Description:
*/
import React from 'react';
import { compose } from 'recompose';
import SvgIcon from '../../svg-icon/SvgIcon';
import accessibleIcon from '../../accessible-icon/accessible-icon';
import branded from '../../with-brand/with-brand';
import getIconClasses from '../../../lib/get-icon-classes/get-icon-classes';
import styles from './PrintIcon.less';

var PrintIcon = function PrintIcon(_ref) {
  var brand = _ref.brand,
      keepProps = _objectWithoutProperties(_ref, ["brand"]);

  var classNames = getIconClasses({
    styles: styles,
    classes: ['print'],
    brand: brand
  });
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, keepProps, {
    className: classNames
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.71 5H13V1.145C13 .514 12.486 0 11.856 0H4.145C3.514 0 3 .514 3 1.145V5H1.29A1.29 1.29 0 0 0 0 6.29v5.42C0 12.423.578 13 1.29 13H3v-2.354c0-.357.289-.646.645-.646h8.711c.356 0 .644.289.644.646V13h1.71A1.29 1.29 0 0 0 16 11.71V6.29A1.29 1.29 0 0 0 14.71 5zM4 1.145c0-.08.065-.145.145-.145h7.711c.079 0 .144.065.144.145V5H4V1.145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11h8v1H4zm0 2h8v1H4zm0 2h8v1H4z"
  }));
};

PrintIcon.defaultProps = {
  width: '16px',
  height: '16px',
  viewBox: '0 0 16 16'
};
export default /*#__PURE__*/React.memo(compose(accessibleIcon, branded)(PrintIcon));